import React, { Component } from "react";

class AccessoriesListing extends Component {
  constructor(props) {
    super(props);
    this.state = { series: [], totalMatching: 0 };
  }

  componentDidMount() {
    fetch(i18n.baseUrl + "api/seriesfilter/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        code: this.props.productCode,
        pageSize: 1000,
      }),
    })
      .then((res) => res.json())
      .then((data) => this.setState({ series: data.items, totalMatching: data.totalMatching }));
  }

  render() {
    return (
      <>
        {this.state.totalMatching == 0
          ? null
          : this.state.series?.map((row) => (
              <div className="c-series__item" key={row.code}>
                <div className="c-series-card">
                  <div className="c-series-card__outer">
                    <div className="c-series-card__inner">
                      <a
                        className="stretched-link"
                        href={this.props.productUrl + "?filters=SeriesCodes=SeriesCodes:" + row.code + "#parts"}
                      >
                        <div className="c-series-card__image">
                          <img src={i18n.CdnHostName + row.imageUrl + "?preset=c-series-list&width=170"} />
                        </div>
                        {row.tags.length ? <div className="c-product-card__tag">{row.tags[0]}</div> : null}
                        <h4 className="c-series-card__heading">{row.name}</h4>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
      </>
    );
  }
}

export default AccessoriesListing;
